module.exports = __webpack_public_path__ + "img/lead-04z.7b62ed0c.png";